(function () {
  'use strict';
  function animateCounter(el, target, duration) {
    var start = 0;
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var value = Math.floor(progress * (target - start) + start);
      el.textContent = value.toLocaleString();
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target.toLocaleString();
      }
    }
    requestAnimationFrame(step);
  }
  function initCounters() {
    var counters = document.querySelectorAll('.counter');
    if (!counters.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(counters, function (el) {
        var n = parseInt((el.textContent || '0').replace(/[^0-9]/g, ''), 10);
        if (!isNaN(n)) animateCounter(el, n, 2000);
        el.classList.add('animated', 'fadeIn');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.dataset.counted) return;
        el.dataset.counted = '1';
        var n = parseInt((el.textContent || '0').replace(/[^0-9]/g, ''), 10);
        if (!isNaN(n)) animateCounter(el, n, 2000);
        el.classList.add('animated', 'fadeIn');
        observer.unobserve(el);
      });
    }, { threshold: 0.2 });
    Array.prototype.forEach.call(counters, function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounters);
  } else {
    initCounters();
  }
})();
